var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"dialog",attrs:{"config":_vm.config,"beforeClose":_vm.beforeClose,"visible":_vm.visible,"cancelDialog":_vm.cancelDialog,"confirmDialog":_vm.confirmDialog,"isdeling":_vm.isdeling}},[_c('p',{staticClass:"text"},[_vm._v(" 退出后无法查看该公司数据， 请确认是否继续退出？ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }